// extracted by mini-css-extract-plugin
module.exports = {"root":"ConnectionError_root__c0jBJ","icon":"ConnectionError_icon__2PF0o","text":"ConnectionError_text__6SzXK","inverted":"ConnectionError_inverted__3CAGz"};